<template>
    <div class="course_perfectinfo">
        <div class="course_perfectinfo_page">
            <div class="navigation">
                <div class="left" @click="goBack"><i class="icon-thin_back"></i></div>
                <div class="content">{{navTitle}}</div>
            </div>
            <div class="course_perfectinfo_content">
                <div class="title">完善个人信息</div>
                <div class="psw_login">
                    <div class="user_name">
                        <span class="add-on"><i class="fa icon-user"></i></span>
                        <input id="textUserName"  placeholder="请输入用户名" type="text" value="">
                    </div>
                    <div class="psw">
                        <span class="add-on"><i class="fa icon-password"></i></span>
                        <input id="textPSW"  placeholder="输入6-12位字符" type="password" value="">
                    </div>
                    <div class="btn_psw_login" @click="finishClick">完成</div>
                    <div class="btn_psw_bottom">注册后可在小花生App登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import {Indicator, Toast} from "mint-ui";

    export default {
        name: "perfectinfo",
        data() {
            return {
                navTitle:""
            }
        },
        methods:{
            goBack:function () {
                let that = this;
                that.goBack(this.$router);
            },
            judgePhoneNumber: function (phoneNumber, phoneCode) {
                if (phoneNumber == null || phoneNumber.length === 0) {
                    Toast('手机号码不存在');
                    return false;
                }

                if (phoneCode !== "86") {
                    return true;
                }

                var reg_phone = /^0?(13[0-9]|15[012356789]|18[0123456789]|14[57]|17[678]|170[059]|14[57]|166|19[89])[0-9]{8}$/;

                if (!reg_phone.test(phoneNumber)) {
                    Toast('手机号格式不正确');
                    return false;
                }

                return true;
            },
            finishClick:function () {
                let that = this;

                let vPhoneNumber = this.$route.query.phoneNumber;
                let vPhoneCode = this.$route.query.phoneCode;

                if (!that.judgePhoneNumber(vPhoneNumber, vPhoneCode)) {
                    return;
                }

                let vUserName = $.trim($("#textUserName").val());
                let vPSW = $.trim($("#textPSW").val());

                if (that.isEmpty(vUserName)) {
                    Toast('请输入用户名');
                    return;
                }

                if (that.isEmpty(vPSW)) {
                    Toast('请输入密码');
                    return;
                }

                if (vPSW.length < 6 || vPSW.length > 12) {
                    Toast('请输入6-12位字符密码');
                    return;
                }

                Indicator.open('提交中...');
                this.$axios.post("/my/registerUserForWeb/",{
                    phoneNumber:vPhoneNumber,
                    userName:vUserName,
                    password:vPSW,
                    phoneAreaCode: vPhoneCode
                }).then((response) => {
                    let vResult = that.getCount(response.data);
                    Indicator.close();

                    // -1其他错误/-2用户名必填/-3用户名重复/-4手机号必填/-5手机号重复/-6昵称包含违反社区规定的内容，请修改后再试试吧/大于0表示用户ID
                    if (vResult === -2) {
                        Toast('请输入用户名');
                    } else if (vResult === -3) {
                        Toast('对不起，这个用户名别人已经使用，请换一个');
                    } else if (vResult === -4) {
                        Toast('手机号必填');
                    } else if (vResult === -5) {
                        Toast('该手机号已被其他用户绑定');
                    }  else if (vResult === -5) {
                        Toast('昵称包含违反社区规定的内容，请修改后再试试吧');
                    } else if (vResult > 0) {
                        this.$store.dispatch('SetToken', vResult);
                        this.$store.dispatch('SetUserId', vResult);

                        this.goBack2(this.$router);
                    } else {
                        Toast('系统异常，请重试');
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            }
        }
    }
</script>

<style scoped>
    .course_perfectinfo {
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
        text-align: center;
    }
    .course_perfectinfo_page {
        position:absolute;
        max-width: 590px;
        background-color: white;
        width: 100%;
        height: 100%;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .course_perfectinfo_content {
        position: absolute;
        width: 300px;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .navigation {
        width: 100%;
        height: 44px;
        position: fixed;
        border-bottom: 1px solid #E5E3E3;
        background-color: white;
        max-width: 590px;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 100%;
        color: #333333;
        font-size: 20px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .content {
        float: left;
        height: 100%;
        width: calc(100% - 50px - 15px);
        text-align: center;
        line-height: 44px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }
    .course_perfectinfo .title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }
    .psw_login {
        margin-top: 50px;
        text-align: left;
    }
    .psw_login .user_name,  .psw_login .psw {
        display: inline-block;
        vertical-align: middle;
        width: 100%;
        height: 44px;
        margin-bottom: 15px;
        font-size: 0;
        white-space: nowrap;
    }
    .psw_login .add-on {
        display: inline-block;
        width: 44px;
        height: 100%;
        background: none;
        font-size: 18px;
        font-weight: normal;
        line-height: 44px;
        border-radius: 4px 0 0 4px;
        margin-right: -1px;
        vertical-align: top;
        min-width: 16px;
        padding: 4px 5px;
        text-align: center;
        text-shadow: 0 1px 0 white;
        border: 1px solid #ccc;
        white-space: nowrap;
    }
    .psw_login .add-on .fa {
        display: inline-block;
        font: normal normal normal 14px/1 FontAwesome;
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        transform: translate(0, 0);
    }
    .psw_login input {
        width: calc(100% - 44px);
    }
    .psw_login input {
        display: inline-block;
        height: 44px;
        padding: 4px 12px;
        box-sizing: border-box;
        margin-bottom: 0;
        position: relative;
        -webkit-border-radius: 0 4px 4px 0;
        -moz-border-radius: 0 4px 4px 0;
        border-radius: 0 4px 4px 0;
        font-size: 14px;
        background-color: white;
        border: 1px solid #cccccc;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
        -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
        -o-transition: border linear 0.2s, box-shadow linear 0.2s;
        transition: border linear 0.2s, box-shadow linear 0.2s;
        line-height: 20px;
        color: #555555;
        outline-style: none ;
        text-shadow: none ;
        -webkit-appearance: none ;
        -webkit-user-select: text ;
        outline-color: transparent ;
    }
    .psw_login input[class*="span"] {
        float: none;
        margin-left: 0;
    }
    .psw_login input:focus {
        border: 1px solid #78baee;
    }
    .psw_login .btn_psw_login {
        margin-top: 20px;
        width: 100%;
        height: 44px;
        background-color:#ff505a;
        line-height: 44px;
        color: white;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
    }
    .btn_psw_bottom {
        font-size: 14px;
        color: #999999;
        text-align: center;
        margin-top: 15px;
    }
</style>
